import React, { useEffect, useState, useContext } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { useMarket } from '../../../utils/market'
import { useConnection } from '../../../utils/connection'
import { useCompanyConn } from '../../../utils/company'
import UserContext from '../../../context/UserContext'
import * as moment from "moment-timezone"
import { HealthServiceDataViewStatus } from './HealthStatusService'
import envConfig from '../../../utils/envConfig'



const HealthStatusServiceConnection = ({ data, env, serviceGroup }) => {

    const marketLookup = useMarket()
    const companyLookup = useCompanyConn(env)
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    const token = useContext(UserContext)

    // we optimise the list of connections to look so that data fetched remains small
    // in int-dev-cert without filter can be 2.4mb
    const [connectionList, setConnectionList] = useState([])
    useEffect(() => {
        let tempList = []
        data.forEach(row => {
            tempList.push(parseInt(row.id))
        });
        setConnectionList(tempList)
    }, [data])
    const connectionLookup = useConnection(env, connectionList, true)

    const tab_col = [
        {
            field: "id",
            headerName: "Id",
            minWidth: 150,
            checkboxSelection: true,
        },
        {
            field: "connectionName",
            headerName: "Name",
            minWidth: 150
        },
        {
            field: "companyName",
            headerName: "Company",
            minWidth: 150
        },
        {
            field: "marketName",
            headerName: serviceGroup === "oc" ? "Market" : "ConnType",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "session",
            headerName: "Session",
            minWidth: 150
        },
        {
            field: "primary",
            headerName: "Primary",
            minWidth: 150
        },
        {
            field: "secondary",
            headerName: "Secondary",
            minWidth: 150
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 200,
            cellStyle: function (params) {
                if (params.value === 'up') {
                    return { color: 'black', backgroundColor: 'white' };
                } else if (params.value.toLowerCase() === 'exchange scheduled down' || params.value.indexOf("Empty order routing parameter") > -1 || params.value.indexOf("No users mapped to connection") > -1) {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else if (params.node.data.newConnection === 'YES') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else {
                    return { color: 'white', backgroundColor: '#B4130B' };
                }
            }
        },
        {
            field: "newConnection",
            headerName: "New",
            minWidth: 80,
            cellStyle: function (params) {
                if (params.node.data.status === 'up') {
                    return { color: 'black', backgroundColor: 'white' };
                }
                else if (params.value === 'YES') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else if (
                    params.node.data.status === 'up' ||
                    params.node.data.status.toLowerCase() === 'exchange scheduled down' ||
                    params.value.indexOf("Empty order routing parameter") > -1
                ) {
                    return { color: 'black', backgroundColor: 'white' };
                }
                else {
                    return { color: 'white', backgroundColor: '#B4130B' };
                }
            }
        },
        {
            field: "datetimelastup",
            headerName: "Last Connected",
            minWidth: 200,
            cellStyle: function (params) {
                if (params.node.data.status === 'up') {
                    return { color: 'black', backgroundColor: 'white' };
                }
                else if (params.data.newConnection === "YES") {
                    return { color: 'white', backgroundColor: '#A6A6A6' }
                }
            },
        }
    ]

    function OCDataSort(order_connector_data) {
        let byStatus = {
            up: [],
            scheduled_down: [],
            unhealthy: [],
            new: [],
            down: [],
            notconnected: [],
        }

        order_connector_data.forEach(row => {
            if (row.status) {
                if (row.status === 'up') byStatus.up.push(row)
                else if (row.status.toLowerCase() === 'exchange scheduled down') byStatus.scheduled_down.push(row)
                else if (row.status.indexOf("Empty order routing parameter") > -1) byStatus.scheduled_down.push(row)
                else if (row.status.indexOf("No users mapped to connection") > -1) byStatus.scheduled_down.push(row)
                else if (row.status.indexOf("down") > -1) byStatus.down.push(row)
                else if (row.status.indexOf("Not Connected") > -1) byStatus.notconnected.push(row)
                else if (row.newConnection === 'YES' && row.lastup !== 'up') byStatus.new.push(row)
                else if (row.status === 'up') byStatus.up.push(row)
                else byStatus.unhealthy.push(row)
            }
        })

        // Sorting by unhealthy > scheduled_down > up
        let finalizedStatus = []
        finalizedStatus = finalizedStatus.concat(byStatus.unhealthy)
        finalizedStatus = finalizedStatus.concat(byStatus.down)
        finalizedStatus = finalizedStatus.concat(byStatus.new)
        finalizedStatus = finalizedStatus.concat(byStatus.scheduled_down)
        finalizedStatus = finalizedStatus.concat(byStatus.up)
        finalizedStatus = finalizedStatus.concat(byStatus.notconnected)
        return finalizedStatus
    }

    // Adding datetimelastup
    const [tab_data, settab_data] = useState([])

    useEffect(() => {

        let finalData = []

        if (connectionLookup && companyLookup && Object.keys(connectionLookup).length > 0 && Object.keys(companyLookup).length > 0) {
            data.forEach(entry => {

                // Determine LastUp
                let datetimelastup = '-'
                datetimelastup = entry.id && connectionLookup[entry.id] ? (connectionLookup[entry.id].datetimelastup === '' ? '-' : connectionLookup[entry.id].datetimelastup) : '-'

                // Determine New Connection
                let newConnection = 'YES'
                newConnection = (datetimelastup === '-' ? 'YES' : 'NO')

                // Host/Port detail
                let primary = entry.id && connectionLookup[entry.id] ? connectionLookup[entry.id].primary : '-'
                let secondary = entry.id && connectionLookup[entry.id] ? connectionLookup[entry.id].secondary : '-'

                //Entries not up for more than 1 month considered new
                const monthago = moment().subtract(1, 'months')
                if ((moment(datetimelastup).tz(token.timezone)).isBefore(monthago)) {
                    newConnection = 'YES'
                }

                finalData.push({
                    newConnection: newConnection,
                    datetimelastup: datetimelastup,
                    id: entry.id,
                    status: entry.status,
                    session: entry.session,
                    type_id: entry.type_id,
                    market_id: entry.market_id,
                    primary: primary,
                    secondary: secondary
                })

            });
        }

        if (companyLookup && connectionLookup && finalData.length > 0) {
            settab_data(OCDataSort(finalData).reduce((rowData, row) => {
                const companyName = row.id && companyLookup[row.id] ? companyLookup[row.id].name : '-'

                let datetimelastup = '-'
                if (row.datetimelastup !== '-') {
                    datetimelastup = moment(moment(row.datetimelastup).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                    datetimelastup = moment(datetimelastup).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                }
                const tabs = [
                    {
                        'type': 'json',
                        'subheader': 'Traders',
                        'content': !row.traders || row.traders.length === 0 ? [{ "data": "No Traders" }] : row.traders,
                    },
                    {
                        'type': 'session_history',
                        'subheader': 'History',
                        'content': {
                            'sessionId': row.id,
                            'sessionType': "connections",
                            'env': env
                        },
                    },
                    {
                        'type': 'json',
                        'subheader': 'Connection',
                        'content': connectionLookup[row.id],
                    },
                ]

                let marketName = '-'
                const connLookup = connectionLookup[row.id]
                const TT_MARKET_ID_FIXGWORDERS = "1004"
                const TT_MARKET_ID_TALOS = "1007"
                const TT_MARKET_ID_CRYPTO_GW = "1008"


                if (row.market_id &&
                    row.market_id !== TT_MARKET_ID_FIXGWORDERS &&
                    row.market_id !== TT_MARKET_ID_TALOS &&
                    row.market_id !== TT_MARKET_ID_CRYPTO_GW) {
                    marketName = marketLookup[row.market_id] ? marketLookup[row.market_id].name : '-'

                } else if (
                    row.market_id &&
                    (row.market_id === TT_MARKET_ID_FIXGWORDERS ||
                        row.market_id === TT_MARKET_ID_TALOS ||
                        row.market_id === TT_MARKET_ID_CRYPTO_GW) &&
                    connLookup && connLookup.connectionType.typeName
                ) {
                    marketName = connLookup.connectionType.typeName
                }

                rowData.push({
                    'uniqueId': row.id + "_" + row.market_id,
                    'id': row.id,
                    'companyName': companyName,
                    'connectionName': connectionLookup[row.id] ? connectionLookup[row.id].name : '-',
                    'marketId': row.market_id,
                    'marketName': marketName,
                    'status': row.status,
                    'session': row.session,
                    'datetimelastup': datetimelastup,
                    'newConnection': row.newConnection,
                    'primary': row.primary,
                    'secondary': row.secondary,
                    'detailView': {
                        'head': {
                        },
                        'data': tabs
                    },
                })

                return rowData
            }, []))
        }

    }, [connectionLookup, companyLookup, data, env, marketLookup, token.timezone, liteMode])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Connections </Text>
                <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
            </Box>
            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceConnection5"
                defaultSubTab="Traders"
                countTitle="Connections"
                tableHeight={700}
                selection="multiple"
            />

        </Box>
    )
}

export default HealthStatusServiceConnection